import $ from 'jquery';
import './jquery.details';


//console.log('Shimming <details>');
$('details').details();
